import React, { useContext, useEffect, useRef, useState } from 'react';
import { Field, Form, Formik } from 'formik';
import { useHistory } from 'react-router-dom';
import * as yup from 'yup';

import Row from 'components/Grid/Row';
import Col from 'components/Grid/Col';
import { ButtonContainer, ButtonMiradorOrange } from 'components/Button';
import { Text } from 'components/Text';
import Loader from 'components/Loader';
import Colors from 'constants/Colors';
import { FitinsurAPI, MessageCenter } from 'utils';
import FitFormTolls from 'utils/src/fitinsur-form-tolls';
import { GlobalAuthContext, GlobalLoaderContext, GlobalOperationContext } from 'store/context';
import Mask from 'utils/src/mask';
import { ButtonContent } from './styles';

export default function Page7({ match }) {

  const loading = useContext(GlobalLoaderContext);
  const authContext = useContext(GlobalAuthContext);
  const operationContext = useContext(GlobalOperationContext);
  const idOperation = match.params.idOperation;
  const history = useHistory();
  const formikRef = useRef(null);
  const [questions, setQuestions] = useState([]);
  // main execution
  const fitinsur = new FitinsurAPI();
  const mc = new MessageCenter();
  const fitForm = new FitFormTolls();
  const fieldQuestions = {
    birthDate: "190",
    gender: "196",
    anosAposentadoria: "193",
    mntContribution: "194",
    termType: "195",
    timeCourse: "201",
  };
  const initialValues = {
    190: "",
    193: "",
    194: "",
    195: "",
    196: ""
  }
  const validation = yup.object().shape({
    "190": fitForm.verifyRequired(fieldQuestions.birthDate, questions)
      ? yup.string().required('Campo Obrigatório')
      : yup.string().notRequired(),
    "193": fitForm.verifyRequired(fieldQuestions.anosAposentadoria, questions)
      ? yup.string().required('Campo Obrigatório')
      : yup.string().notRequired(),
    "194": fitForm.verifyRequired(fieldQuestions.mntContribution, questions)
      ? yup.string().required('Campo Obrigatório')
      : yup.string().notRequired(),
    "195": fitForm.verifyRequired(fieldQuestions.termType, questions)
      ? yup.string().required('Campo Obrigatório')
      : yup.string().notRequired(),
    "196": fitForm.verifyRequired(fieldQuestions.gender, questions)
      ? yup.string().required('Campo Obrigatório')
      : yup.string().notRequired(),
  })

  const goBack = () => {
    history.goBack();
  }

  let messageHeader = () => {
    return (
      <><div>
        <h4 style={{ fontWeight: "bold", marginTop: "10px" }}>
          Que ótimo, {getName()}!
          <br />
          Queremos saber mais sobre você:
        </h4>
      </div>
      </>
    );
  }

  const handleSubmit = async (values) => {
    loading.start();
    console.log("Valores submetidos-> ", values);
    // Percorrendo respostas e gravando no contexto
    Object.keys(values).forEach((idQuestion) => {
      const item = questions.find(element => element.idQuestion.toString() === idQuestion);

      let qst = {
        idAnswerOption: Array.isArray(values[idQuestion])
          ? values[idQuestion].map((option) => option.idAnswerOption?.toString())
          : values[idQuestion].idAnswerOption?.toString(),
        idDomainPersonRole: item.idDomainPersonRole,
        idQuestion: Number(idQuestion),
        idQuestionnaire: item.idQuestionnaire,
        questionDomain: item.questionDomain,
        textQuestionAnswer: Array.isArray(values[idQuestion])
          ? values[idQuestion].map((answer) => answer.answerOptionDescription)
          : values[idQuestion].dsAnswerOption
            ? values[idQuestion].dsAnswerOption
            : values[idQuestion].answerOptionDescription
              ? values[idQuestion].answerOptionDescription
              : values[idQuestion],
      };

      if (item.idQuestionnaire === 24) {
        // person questionarie
        if(item.idQuestion === 190){
          qst.textQuestionAnswer = stringToDate(qst.textQuestionAnswer);
          console.log("Data processada", qst.textQuestionAnswer);
        }
        const index = operationContext.add2_request.personQuestionnaire.findIndex(element => element.idQuestion === qst.idQuestion);
        operationContext.add2_request.personQuestionnaire[index] = qst;
        return;
      }

      if (item.idQuestionnaire === 25) {
        // risk questionarie
        const index = operationContext.add2_request.riskQuestionnaire.findIndex(element => element.idQuestion === qst.idQuestion);
        operationContext.add2_request.riskQuestionnaire[index] = qst;
        return;
      }
    });
    
    // Adicionando parametro para troca de status 7 para 1
    operationContext.add2_request["isConfirmation"] = true;
    
    // Salvando contexto no localStorage
    localStorage.setItem("fitOperation", JSON.stringify(operationContext));

    // Submetendo formulário
    fitinsur.setAuthToken(authContext.token);
    fitinsur.requestAddAction2(operationContext.add2_request)
      .then((response) => response.json())
      .then((data) => {

        if (Array.isArray(data)) {
          if (data[5].acceptResultFinal === false) {
            mc.error('Sem planos disponíveis no momento para esse perfil.');
            return;
          };
          if (data[8].ret_code && data[8].ret_code === 200) {
            operationContext.add2_response = data;
            localStorage.setItem("fitOperation", JSON.stringify(operationContext));
            loading.stop();
            history.push(`/embed/page8/${idOperation}`)
            return;
          }
        }
        if (data.ret_code !== 200) {
          mc.error(data.ret_msg_details);
        }
      })
      .catch((e) => {
        console.log(e);
      })
      .finally(()=>{
        loading.stop();
      });
  };

  const stringToDate = (string) => {
    console.log('data', string);
    let parts = string.split('/');
    let date = new Date(`${parts[1]}/${parts[0]}/${parts[2]}`);
    console.log('data formatada', date);
    return date;
  }

  const getName = () => {
    const name = operationContext.add2_request.personQuestionnaire.find(qst => qst.idQuestion === 189).textQuestionAnswer;
    return name.split(' ',1);
  };

  useEffect(() => {
    //loading.start();
    const auxQuestions = [
      ...operationContext.add_response.operationQuestionnaire,
      ...operationContext.add_response.personQuestionnaire,
      ...operationContext.add_response.riskQuestionnaire,
    ]
    setQuestions(auxQuestions);

    //loading.stop();
  }, [])

  return (
    <>
      <Row>
        <Col>

        </Col>
        <Col style={{ display: "flex", justifyContent: "flex-end" }}>
          <Text
          //onClick={() => { console.log('SEARCH', values); }} 
          ></Text>
          <button onClick={(e) => { e.stopPropagation(); e.preventDefault() }} style={{ opacity: 0, width: 0, height: 0 }}></button>
        </Col>

      </Row>
      <Formik
        innerRef={formikRef}
        enableReinitialize={true}
        initialValues={initialValues}
        onSubmit={(values) => handleSubmit(values)}
        validationSchema={validation}
      >
        {({ values, setFieldValue }) => (
          <Form>
            <Row>
              <h5
                style={{ margin: "0px 0px 0px 15px", fontWeight: "normal" }}
                onClick={() => goBack()}
              >
                voltar
              </h5>
            </Row>
            <Row style={{ textAlign: "center", justifyContent: "center" }}>{messageHeader()}</Row>
            <Row><hr style={{ width: "100%", boxShadow: "rgba(0, 0, 0, 0.05) 1px 3px 5px 1px" }} /></Row>

            <Row>
              <Col>
                <Field
                  name={fieldQuestions.birthDate}
                  label={fitForm.getDsQuestion(fieldQuestions.birthDate, questions)}
                  component={fitForm.verifyComponent(fieldQuestions.birthDate, questions)}
                  onChange={(value) => setFieldValue(fieldQuestions.birthDate, Mask.date(value))}
                />
                <Field
                  name={fieldQuestions.gender}
                  label={fitForm.getDsQuestion(fieldQuestions.gender, questions)}
                  component={fitForm.verifyComponent(fieldQuestions.gender, questions)}
                  options={fitForm.verifyOptions(fieldQuestions.gender, questions)}
                />
                <Field
                  name={fieldQuestions.anosAposentadoria}
                  label={fitForm.getDsQuestion(fieldQuestions.anosAposentadoria, questions)}
                  component={fitForm.verifyComponent(fieldQuestions.anosAposentadoria, questions)}
                  options={fitForm.verifyOptions(fieldQuestions.anosAposentadoria, questions)}
                />
                <Field
                  name={fieldQuestions.mntContribution}
                  label={fitForm.getDsQuestion(fieldQuestions.mntContribution, questions)}
                  component={fitForm.verifyComponent(fieldQuestions.mntContribution, questions)}
                  onChange={(value) => setFieldValue(fieldQuestions.mntContribution, Mask.currency({
                    value: value,
                    lang: "pt-br",
                    currency: 'BRL',
                    style: 'currency'
                  }))}
                />
                <Field
                  name={fieldQuestions.termType}
                  label={fitForm.getDsQuestion(fieldQuestions.termType, questions)}
                  component={fitForm.verifyComponent(fieldQuestions.termType, questions)}
                  options={fitForm.verifyOptions(fieldQuestions.termType, questions)}
                />
                <Field
                  name={fieldQuestions.timeCourse}
                  label={fitForm.getDsQuestion(fieldQuestions.timeCourse, questions)}
                  component={fitForm.verifyComponent(fieldQuestions.timeCourse, questions)}
                  options={fitForm.verifyOptions(fieldQuestions.timeCourse, questions)}
                />
              </Col>
            </Row>
            <Row style={{ textAlign: "center", justifyContent: "center" }}>
              <h6 style={{ fontWeight: "normal" }}>Está em dúvida? Não se preocupe, depois você poderá<br />
                alterar este valor sempre que desejar.</h6>
            </Row>

            <ButtonContainer style={{ justifyContent: "center" }}>
              <ButtonContent>

                <ButtonMiradorOrange
                  type="submit"
                  primary
                  id="btnSubmit"
                >
                  SIMULAR AGORA
                </ButtonMiradorOrange>

              </ButtonContent>
            </ButtonContainer>
            <Row><Col><br /></Col></Row>
          </Form>
        )}
      </Formik>
      {loading.active && <Loader backdropColor={Colors.WHITE} fullScreen />}
    </>
  )
}